import { Injectable, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private document = inject(DOCUMENT);
  private currentTheme = signal<'light-theme' | 'dark-theme'>('light-theme');

  constructor() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark-theme') {
      this.setTheme('dark-theme');
    } else {
      this.setTheme('light-theme');
    }
  }

  toggleTheme(): void {
    const newTheme = this.currentTheme() === 'light-theme' ? 'dark-theme' : 'light-theme';
    this.setTheme(newTheme);
  }

  private setTheme(theme: 'light-theme' | 'dark-theme'): void {
    this.document.body.classList.remove('light-theme', 'dark-theme');
    this.document.body.classList.add(theme);
    localStorage.setItem('theme', theme);
    this.currentTheme.set(theme);
  }

  isDarkTheme() {
    return this.currentTheme() === 'dark-theme';
  }
}
